import { useAnalyticsStore } from '@/store/app'
import request from '@/services/api'

async function login(postData: any) {
  const apiUrl = `${import.meta.env.VITE_BASE_API_URL}/auth/login`

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function signup(postData: any) {
  const analyticsStore = useAnalyticsStore()

  const apiUrl = `${import.meta.env.VITE_BASE_API_URL}/schools/register`

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Deep-Link-Params': Object.entries(analyticsStore.queryParams)
          .map(([key, value]) => `${key}=${value}`)
          .join(',')
      },
      body: JSON.stringify(postData)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function recoverPassword(postData: any) {
  const apiUrl = `${import.meta.env.VITE_BASE_API_URL}/auth/reset-password`

  try {
    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    console.log('Success')
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function getCustomToken() {
  const path = '/schools/custom-token'

  try {
    const response = await request(path, {
      method: 'GET'
    })

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`)
    }

    // console.log('Success)
    return response.text()
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export default { login, signup, recoverPassword, getCustomToken }
